import React from 'react';

import { PATHS } from '../../common/constants';
import Anchor from '../../components/Anchor';
import Auth from '../../layouts/Auth/Auth';
import { Images } from '../../Tenants';
import './LinkValidation.scss';

const LinkValidation = ({
    message
}) => {
    return (
        <Auth
            title=""
            backgroundImage={Images.signInImage}
            content={(
                <div className="sign-in linkvalidation">
                        <div className="sign-in-header">
                            <div className="sign-in-headline">
                                {message}
                            </div>
                        </div>

                        <div className="sign-in-footer">
                        {'Click here to'}{' '}
                            <Anchor
                                path={PATHS.AUTH_SIGN_IN}
                                label="sign in"
                            />
                        </div>
                </div>
            )}
        />
    )
}

export default LinkValidation;